<template>
  <div class="p-4">
    <vx-card class="overflow-hidden relative org-card mb-4">
      <img
        class="absolute right-0 z-0"
        src="@/assets/background/TreasuryOrgCardBackground.svg"
        alt="Treasury Org Card Background"
      />
      <div
        class="flex md:flex-row flex-col md:gap-y-0 gap-y-12 justify-center w-full z-10 relative"
      >
        <deposit-funds />
        <div
          class="flex flex-col items-center border-right w-full md:w-3/12 min-width justify-between"
        >
          <vs-avatar
            v-if="orgData.logo"
            class="my-4 profile-picture"
            size="100px"
            :src="constants.s3Bucket + '/organization/logo/' + orgData.logo"
          />
          <div class="flex flex-col gap-y-2">
            <span class="extrabold font-bold text-xl">{{
              orgData.name || ""
            }}</span>
            <p>{{ orgData.website }}</p>
          </div>
        </div>
        <div class="flex flex-col gap-y-4 md:w-9/12 w-full px-12">
          <div class="flex flex-col">
            <span class="text-2xl font-bold">Treasury</span>
            <small>Uptalk Organisation Treasury</small>
          </div>
          <div class="flex w-full justify-between md:flex-nowrap flex-wrap">
            <div class="flex flex-col gap-y-8">
              <div class="flex flex-col gap-y-2">
                <small class="text-gray uppercase letter-spacing"
                  >Liquidity Pool</small
                >
                <span class="text-black font-bold">Not Configured</span>
              </div>
              <div class="flex flex-col gap-y-2">
                <small class="text-gray uppercase letter-spacing"
                  >Currencies</small
                >
                <span class="text-black font-bold"
                  >€{{ availableFunds ? availableFunds.toFixed(2) : 0 }}</span
                >
              </div>
            </div>
            <div class="flex flex-col gap-y-8">
              <div class="flex flex-col gap-y-2">
                <small class="text-gray uppercase letter-spacing">Token</small>
                <span class="text-black font-bold">Not Configured</span>
              </div>
              <div class="flex flex-col gap-y-2">
                <small class="text-gray uppercase letter-spacing">NFTs</small>
                <span v-if="nftsConfigured" class="text-black font-bold"
                  >Configured</span
                >
                <span v-else class="text-black font-bold">Not Configured</span>
              </div>
            </div>
            <div class="flex flex-col gap-y-8">
              <div class="flex flex-col gap-y-2">
                <small class="text-gray uppercase letter-spacing">XP</small>
                <span class="text-black font-bold">Configured</span>
              </div>
              <!-- <div class="flex flex-col gap-y-2">
                <small class="text-gray uppercase letter-spacing">Euro</small>
                <span class="text-black font-bold">$1237754</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <!-- <vx-card class="overflow-hidden relative org-card mb-4">
      <load-details />
    </vx-card> -->
    <vx-card>
      <vs-table max-items="50" pagination :data="reactiveTransactions">
        <template slot="thead">
          <vs-th class="table-header"> Status </vs-th>
          <vs-th class="table-header"> Date </vs-th>
          <vs-th class="table-header"> Amount </vs-th>
          <vs-th class="table-header"> Transaction </vs-th>
          <vs-th class="table-header"> Type </vs-th>
          <!-- <vs-th> Remark </vs-th> -->
          <vs-th class="table-header"> Details </vs-th>
          <!-- <vs-th> Status </vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              v-if="data[indextr].source === 'market'"
              :data="data[indextr].status"
            >
              <!-- <span
                v-if="
                  data[indextr].redemption_approved &&
                  data[indextr].token_minted
                "
                class="txn-success"
              ></span> -->
              <div class="flex items-center justify-start">
                <vs-tooltip
                  text="Order Fulfilled"
                  v-if="data[indextr].fulfilled"
                >
                  <span class="txn-success"></span>
                </vs-tooltip>
                <vs-tooltip
                  text="Order Rejected"
                  v-else-if="data[indextr].rejected"
                >
                  <span class="txn-failed"></span>
                </vs-tooltip>
                <vs-tooltip text="Order Not Fullfiled" v-else>
                  <span class="txn-not-confirmed"></span>
                </vs-tooltip>
              </div>
            </vs-td>
            <vs-td v-else :data="data[indextr].status">
              <div class="flex items-center justify-start">
                <vs-tooltip
                  text="Transaction Successful"
                  v-if="data[indextr].status.includes('Successful')"
                >
                  <span class="txn-success"></span>
                </vs-tooltip>
                <vs-tooltip text="Transaction Not Confirmed" v-else>
                  <span class="txn-not-confirmed"></span>
                </vs-tooltip>
              </div>
            </vs-td>

            <vs-td v-if="data[indextr].createdAt">
              {{ data[indextr].createdAt.split("T")[0] }}
            </vs-td>
            <vs-td v-else> </vs-td>

            <vs-td v-if="data[indextr].amount">
              <span v-if="!isNaN(parseFloat(data[indextr].currency))">
                {{
                  orgPriceTypes.filter(
                    (price) =>
                      price.key.toString() === data[indextr].currency.toString()
                  )[0].label
                }}
              </span>
              <span v-else> € </span>
              <span>{{ data[indextr].amount * (data[indextr].qty || 1) }}</span>
            </vs-td>
            <vs-td v-else>€ 0 </vs-td>

            <vs-td v-if="data[indextr].fundType">
              <!-- Debit -->
              <div
                class="items-center flex"
                v-if="data[indextr].fundType.toUpperCase() == 'DEBIT'"
              >
                <vs-tooltip
                  :text="'Debited from ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    " />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                /></vs-tooltip>
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <img
                  src="@/assets/Iconography/market/LockIcon.svg"
                  alt="Lock Icon"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <vs-tooltip
                  :text="
                    'Credited to ' +
                    (data[indextr].linkedUserData
                      ? data[indextr].linkedUserData.firstName
                      : '')
                  "
                  v-if="data[indextr].linkedUserData"
                >
                  <vs-avatar
                    v-if="
                      data[indextr].linkedUserData &&
                      data[indextr].linkedUserData.profilePictureUrl
                    "
                    class="profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      data[indextr].linkedUserData.profilePictureUrl
                    " />
                  <vs-avatar
                    v-else
                    class="profile-picture"
                    size="32px"
                    :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      data[indextr].linkedUserData
                        ? data[indextr].linkedUserData.firstName
                        : 'boringAvatar',
                      data[indextr].linkedUserData
                        ? data[indextr].linkedUserData.lastName
                        : 'boringAvatar'
                    )}`"
                /></vs-tooltip>
              </div>
              <!-- Credit -->
              <div
                class="items-center flex justify-content-center"
                style="align-items: center"
                v-if="data[indextr].fundType.toUpperCase() == 'CREDIT'"
              >
                <feather-icon
                  icon="CreditCardIcon"
                  svgClasses="w-10 h-10 mr-1"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <img
                  src="@/assets/Iconography/market/UnlockIcon.svg"
                  alt="Unlock Icon"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <vs-tooltip
                  :text="
                    'Credited to ' +
                    (data[indextr].linkedUserData
                      ? data[indextr].linkedUserData.firstName
                      : '')
                  "
                  v-if="data[indextr].linkedUserData"
                >
                  <vs-avatar
                    v-if="
                      data[indextr].linkedUserData &&
                      data[indextr].linkedUserData.profilePictureUrl
                    "
                    class="profile-picture"
                    size="10px"
                    :src="
                      constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      data[indextr].linkedUserData.profilePictureUrl
                    " />
                  <vs-avatar
                    v-else
                    class="profile-picture"
                    size="32px"
                    :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      data[indextr].linkedUserData
                        ? data[indextr].linkedUserData.firstName
                        : 'boringAvatar',
                      data[indextr].linkedUserData
                        ? data[indextr].linkedUserData.lastName
                        : 'boringAvatar'
                    )}`"
                /></vs-tooltip>
              </div>
              <!-- Deposit -->
              <div
                class="items-center flex"
                v-if="data[indextr].fundType.toUpperCase() == 'DEPOSIT'"
              >
                <feather-icon
                  icon="CreditCardIcon"
                  svgClasses="w-10 h-10 mr-1"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <img
                  src="@/assets/Iconography/market/LockIcon.svg"
                  alt="Lock Icon"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <vs-avatar
                  v-if="
                    data[indextr].linkedUserData &&
                    data[indextr].linkedUserData.profilePictureUrl
                  "
                  class="profile-picture"
                  size="32px"
                  :src="
                    constants.s3Bucket +
                    '/editor/profile-pictures/' +
                    data[indextr].linkedUserData.profilePictureUrl
                  "
                />
                <vs-avatar
                  v-else
                  class="profile-picture"
                  size="32px"
                  :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                    data[indextr].linkedUserData
                      ? data[indextr].linkedUserData.firstName
                      : 'boringAvatar',
                    data[indextr].linkedUserData
                      ? data[indextr].linkedUserData.lastName
                      : 'boringAvatar'
                  )}`"
                />
              </div>
              <!-- Locked -->
              <div
                class="items-center flex"
                v-if="data[indextr].fundType.toUpperCase() == 'LOCKED'"
              >
                <vs-tooltip
                  :text="'Approved & Assigned by ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </vs-tooltip>
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <img
                  src="@/assets/Iconography/market/LockIcon.svg"
                  alt="Lock Icon"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <vs-tooltip
                  :text="'Approved & Assigned by ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </vs-tooltip>
              </div>
              <!-- Unlock -->
              <div
                class="items-center flex"
                v-if="data[indextr].fundType.toUpperCase() == 'UNLOCKED'"
              >
                <vs-tooltip
                  :text="'Approved & Assigned by ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </vs-tooltip>
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>

                <img
                  src="@/assets/Iconography/market/UnlockIcon.svg"
                  alt="Unlock Icon"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <vs-tooltip
                  :text="'Approved & Assigned by ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </vs-tooltip>
              </div>
              <!-- Refund -->
              <div
                class="items-center flex"
                v-if="data[indextr].fundType.toUpperCase() == 'REFUND'"
              >
                <vs-tooltip
                  :text="'Approved & Assigned by ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </vs-tooltip>
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <img
                  src="@/assets/Iconography/market/UnlockIcon.svg"
                  alt="Unlock Icon"
                />
                <div style="color: #a6f4c5">
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <vs-tooltip
                  :text="'Approved & Assigned by ' + orgData.name"
                  v-if="orgData.name"
                >
                  <vs-avatar
                    v-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </vs-tooltip>
              </div>
              <!-- Market -->
              <!-- If order is fulfilled -->
              <div
                class="items-center flex"
                v-if="data[indextr].source == 'market'"
              >
                <vs-tooltip
                  :text="
                    'Approved & Assigned by ' +
                    (data[indextr].linkedUserData
                      ? data[indextr].linkedUserData.firstName
                      : '')
                  "
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                >
                  <vs-button flat class="bg-white shadow-none m-0 p-0">
                    <vs-avatar
                      v-if="
                        data[indextr].fulfilled === true &&
                        data[indextr].fulfilledBy &&
                        data[indextr].fulfilledBy.profilePictureUrl &&
                        Object.keys(data[indextr].fulfilledBy).length > 0
                      "
                      class="profile-picture"
                      size="32px"
                      :src="
                        constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        data[indextr].fulfilledBy.profilePictureUrl
                      "
                    />
                    <vs-avatar
                      v-else
                      class="profile-picture"
                      size="32px"
                      :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        data[indextr].linkedUserData
                          ? data[indextr].linkedUserData.firstName
                          : 'boringAvatar',
                        data[indextr].linkedUserData
                          ? data[indextr].linkedUserData.lastName
                          : 'boringAvatar'
                      )}`"
                    />
                  </vs-button>
                </vs-tooltip>
                <span
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                  style="color: #6172f3"
                >
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </span>
                <!-- Product 4 cases -->
                <div
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                >
                  <div
                    v-if="
                      data[indextr].product_details &&
                      data[indextr].fulfilled === true &&
                      data[indextr].fulfilledBy &&
                      Object.keys(data[indextr].fulfilledBy).length > 0
                    "
                    class="relative"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      class="absolute z-10 transform -translate-x-4 translate-y-12"
                      v-if="hovered == data[indextr] && indextr == 0"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    >
                      <circle cx="16" cy="16" r="16" fill="#F2C244" />
                    </svg>
                    <vs-avatar
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                      v-if="
                        data[indextr].product_details &&
                        data[indextr].fulfilled === true &&
                        data[indextr].fulfilledBy &&
                        Object.keys(data[indextr].fulfilledBy).length > 0 &&
                        hovered == data[indextr] &&
                        indextr == 0
                      "
                      class="transform-avatar-reverse absolute z-20"
                      size="22px"
                      :src="
                        data[indextr].product_details.product_images[0] ||
                        constants.s3Bucket +
                          '/organization/logo/' +
                          orgData.logo
                      "
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      class="absolute left-1/2 transform -translate-x-1/2 -translate-y-10"
                      v-if="hovered == data[indextr] && indextr != 0"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    >
                      <circle cx="16" cy="16" r="16" fill="#F2C244" />
                    </svg>
                    <vs-avatar
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                      v-if="
                        data[indextr].product_details &&
                        data[indextr].fulfilled === true &&
                        data[indextr].fulfilledBy &&
                        Object.keys(data[indextr].fulfilledBy).length > 0 &&
                        hovered == data[indextr] &&
                        indextr != 0
                      "
                      class="transform-avatar absolute"
                      size="22px"
                      :src="
                        data[indextr].product_details.product_images[0] ||
                        constants.s3Bucket +
                          '/organization/logo/' +
                          orgData.logo
                      "
                    />
                    <img
                      src="@/assets/Iconography/market/MarketTransactionIcon.svg"
                      alt="Market Icon"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      class="absolute transform -translate-x-1 rotate-180"
                      v-if="hovered == data[indextr] && indextr == 0"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    >
                      <path
                        d="M4.13397 7.5C4.51887 8.16667 5.48113 8.16667 5.86603 7.5L9.33013 1.5C9.71503 0.833334 9.2339 0 8.4641 0H1.5359C0.766098 0 0.284973 0.833333 0.669873 1.5L4.13397 7.5Z"
                        fill="#F2C244"
                      />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      class="absolute left-1/2 transform -translate-x-1/2 -translate-y-12 z-8 -mt-5 -mr-3"
                      v-if="hovered == data[indextr] && indextr != 0"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    >
                      <path
                        d="M4.13397 7.5C4.51887 8.16667 5.48113 8.16667 5.86603 7.5L9.33013 1.5C9.71503 0.833334 9.2339 0 8.4641 0H1.5359C0.766098 0 0.284973 0.833333 0.669873 1.5L4.13397 7.5Z"
                        fill="#F2C244"
                      />
                    </svg>
                  </div>

                  <vs-avatar
                    v-else
                    class="my-4 profile-picture -mt-4"
                    size="24px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </div>
                <div v-else>
                  <vs-avatar
                    v-if="
                      data[indextr].product_details &&
                      data[indextr].product_details.product_images &&
                      data[indextr].product_details.product_images[0]
                    "
                    class="my-4 profile-picture"
                    size="32px"
                    :src="data[indextr].product_details.product_images[0]"
                  />
                  <vs-avatar
                    v-else-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </div>

                <div
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                  style="color: #6172f3"
                >
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <div v-else style="color: #6172f3"> - - - - - - -</div>

                <vs-tooltip
                  :text="
                    'Ordered by ' +
                    (data[indextr].linkedUserData
                      ? data[indextr].linkedUserData.firstName
                      : '')
                  "
                  v-if="data[indextr].linkedUserData"
                >
                  <vs-button flat class="bg-white shadow-none m-0 p-0">
                    <vs-avatar
                      v-if="
                        data[indextr].linkedUserData &&
                        data[indextr].linkedUserData.profilePictureUrl
                      "
                      class="profile-picture"
                      size="32px"
                      :src="
                        constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        data[indextr].linkedUserData.profilePictureUrl
                      "
                    />
                    <vs-avatar
                      v-else
                      class="profile-picture"
                      size="32px"
                      :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        data[indextr].linkedUserData
                          ? data[indextr].linkedUserData.firstName
                          : 'boringAvatar',
                        data[indextr].linkedUserData
                          ? data[indextr].linkedUserData.lastName
                          : 'boringAvatar'
                      )}`"
                    />
                  </vs-button>
                </vs-tooltip>
              </div>
            </vs-td>

            <vs-td v-else> </vs-td>

            <vs-td v-if="data[indextr].fundType">
              <span
                v-if="data[indextr].source == 'market'"
                class="txn-type-market txn-type flex gap-2 items-center max-w-fit"
              >
                <span class="txn-tip-market txn-tip"></span>
                {{ data[indextr].transactionType }}
              </span>
              <span
                v-else
                class="txn-type-core txn-type flex gap-2 items-center max-w-fit"
              >
                <span class="txn-tip-core txn-tip"></span>
                {{ data[indextr].fundType }}
              </span>
            </vs-td>
            <vs-td v-else> </vs-td>

            <!-- <vs-td v-if="data[indextr].fundType">
            {{ data[indextr].remark }}
          </vs-td>
          <vs-td v-else>
          </vs-td> -->

            <vs-td
              v-if="data[indextr].details || data[indextr].product_details"
            >
              <mint-modal
                :orgId="orgId"
                :logId="data[indextr]._id"
                :fetchTransactions="fetchTransactions"
                :walletAddress="data[indextr].walletAddress"
                :isMarketAdmin="false"
                :productType="
                  data[indextr].product_details
                    .product_mintable_contract_details.contractType
                "
                :loggedContractDetails="
                  data[indextr].product_details
                    .product_mintable_contract_details
                "
                v-if="
                  data[indextr].source === 'market' &&
                  (data[indextr].product_details.isMintable === 'true' ||
                    data[indextr].product_details.isMintable) &&
                  !data[indextr].token_minted
                "
              />
              <transaction-detail
                v-else-if="
                  data[indextr].source === 'market' &&
                  !data[indextr].redemption_approved &&
                  !data[indextr].rejected
                "
                :fetchTransactions="fetchTransactions"
                :orgId="orgId"
                :transactionData="data[indextr]"
              />
              <load-details
                v-else
                load="Load Details"
                accessLevel="admin"
                :transactionDetails="data[indextr]"
                :fetchTransactions="fetchTransactions"
              />
            </vs-td>
            <vs-td v-else> </vs-td>

            <!-- <vs-td v-if="data[indextr].status">
            {{ data[indextr].status }}
          </vs-td>
          <vs-td v-else>
          </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import AddFunds from "../components/AddFunds.vue";
import constants from "@/constants.js";
import TransactionDetail from "./TransactionDetail.vue";
import MintModal from "../../../modals/MintModal.vue";
import LoadDetails from "./LoadDetails.vue";
import DepositFunds from "./DepositFunds.vue";

export default {
  data() {
    return {
      constants,
      showTransactionDetails: {},
      userId: "",
      accessToken: "",
      orgId: "",
      reactiveTransactions: [],
      nftsConfigured: false,
      hovered: false,
    };
  },
  components: {
    AddFunds,
    TransactionDetail,
    MintModal,
    LoadDetails,
    DepositFunds,
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    transactions() {
      return this.$store.state.payments.transactionHistory;
    },
    availableFunds() {
      return this.$store.state.payments.availableFunds;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    orgPriceTypes() {
      return this.$store.state.market.orgPriceTypes;
    },
    orgProductTypes() {
      return this.$store.state.market.orgProductTypes;
    },
  },
  watch: {
    orgData(newVal) {
      if (newVal && newVal._id) {
        this.orgId = newVal._id;
        this.$store.dispatch("payments/fetchFunds", {
          organizationId: newVal._id,
        });
        this.fetchOrgProductAndPriceTypes();
        this.fetchTransactions();
        this.getNFTsConfigured();
        // console.log("orgData", newVal);
      }
    },
  },
  created() {
    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("payments/fetchFunds", {
        organizationId: this.orgData._id,
      });

      this.fetchTransactions();
      this.$store.dispatch("payments/fetchFunds", {
        organizationId: this.orgData._id,
      });
    }
  },
  mounted() {
    this.fetchTransactions();
    this.fetchOrgProductAndPriceTypes();
    this.getNFTsConfigured();
  },
  methods: {
    fetchTransactions() {
      this.$vs.loading();
      this.userId = JSON.parse(localStorage.getItem("user"))._id;
      this.accessToken = localStorage.getItem("accessToken");
      this.orgId = this.orgData._id;
      // console.log(this.userId, this.orgId);
      if (
        this.userId !== undefined &&
        this.accessToken !== undefined &&
        this.orgId !== undefined
      ) {
        // console.log("fetching transactions");
        this.$store
          .dispatch("payments/fetchAllTransactions", {
            organizationId: this.orgId,
            userId: this.userId,
            accessToken: this.accessToken,
          })
          .then((transactions) => {
            this.reactiveTransactions = transactions;
            this.$forceUpdate();
            this.$vs.loading.close();
            // console.log("org product types:", this.orgProductTypes);
          }).catch(()=>{
            this.$vs.loading.close();
          });
      }
    },
    fetchOrgProductAndPriceTypes() {
      const _accessToken = localStorage.getItem("accessToken");
      const payload = { orgId: this.orgId, accessToken: _accessToken };

      if (
        _accessToken &&
        _accessToken !== "" &&
        _accessToken !== null &&
        _accessToken !== undefined &&
        this.orgId !== undefined
      ) {
        this.$store
          .dispatch("organization/fetchOrgProductAndPriceTypes", payload)
          .then((res) => {
            this.$store.commit("market/ORG_PRICE_TYPES", res[0]);
            this.$store.commit("market/ORG_PRODUCT_TYPES", res[1]);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getNFTsConfigured() {
      const _accessToken = localStorage.getItem("accessToken");
      this.userId = JSON.parse(localStorage.getItem("user"))._id;
      const payload = {
        orgId: this.orgId,
        accessToken: _accessToken,
        userId: this.userId,
      };

      if (
        _accessToken &&
        _accessToken !== "" &&
        _accessToken !== null &&
        _accessToken !== undefined &&
        this.orgId !== undefined
      ) {
        this.$store
          .dispatch("market/getNFTsConfigured", payload)
          .then((res) => {
            // console.log("res", res);
            this.nftsConfigured = res.configured;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    showHoveredSVG(data) {
      this.hovered = data;
    },
    hideHoveredSVG() {
      this.hovered = null;
    },
  },
};
</script>

<style scoped>
.deposit-fund-button {
  top: 5px;
  right: 9px;
  border: 2px solid black;
  border-radius: 20px !important;
  background: inherit;
  padding: 7px 14px;
  font-weight: bolder;
}
.deposit-fund-button:hover {
  background: black;
  color: white;
}
.min-width {
  min-width: 150px;
}
.letter-spacing {
  letter-spacing: 2px;
}
.text-gray {
  color: #8c8c8c;
}
.border-right {
  border-right: 1px solid #ebe9fe;
}
.table-header {
  background-color: #f2f4f7;
}
.txn-tip-market {
  background-color: #7a5af8;
}
.txn-tip-core {
  background-color: #fb6514;
}
.txn-tip {
  display: block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.txn-type {
  text-transform: capitalize;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: #ebe9fe;
  border-radius: 16px;
  max-width: fit-content;
}
.txn-type-market {
  background-color: #ebe9fe;
}
.txn-type-core {
  background-color: #ffead5;
}
.txn-not-confirmed {
  padding: 2px;
  display: block;
  border-radius: 50%;
  background-color: #fbb603;
  height: 10px;
  width: 10px;
}
.txn-success {
  padding: 2px;
  display: block;
  border-radius: 50%;
  background-color: #12b76a;
  height: 10px;
  width: 10px;
}
.txn-failed {
  padding: 2px;
  display: block;
  border-radius: 50%;
  background-color: red;
  height: 10px;
  width: 10px;
}
.my-base-large {
  margin: 3rem auto 4rem auto;
}

button {
  border-radius: 8px !important;
}

.invite-btn {
  border-radius: 4px;
}
.vs-table--thead {
  z-index: -10 !important;
}

.coupon-code >>> .vs-con-input input.vs-input--input {
  text-transform: uppercase !important;
}

.vs-con-table >>> .vs-table--not-data {
  display: none !important;
}

.justify-content-end {
  justify-content: end;
}

.available-balance {
  border: 1px solid #f8f8f8;
  min-height: auto;
  height: auto;
}

.available-balance h1 {
  font-size: 37px;
  line-height: 30px;
  font-weight: bold;
}

.x-plus-amount {
  color: #ffffff;
  background-color: rgba(var(--vs-primary));
  border-radius: 15px;
  padding: 2px 5px;
  font-size: 12px;
}

.transform-avatar {
  transform: translateX(-73%) translateY(-159%);
}
.transform-avatar-reverse {
  transform: translateX(-62%) translateY(192%);
}
</style>
<!-- 4*12 -->
